import { Guid } from "@/Common/Models/Guid";
import { FlowsheetConfig } from "./CareElements/FlowsheetConfig";

enum FlowsheetTemplateScope {
    Default = 0,
    Patient = 1,
    Physician = 2,
    Clinic = 3
}

class FlowsheetTemplate {
    public Id: Guid;
    public Name?: string | null;
    public IsDefaultTemplate: boolean;
    public Configuration: FlowsheetConfig;
    public TemplateScope: FlowsheetTemplateScope;

    constructor(args: Omit<FlowsheetTemplate, "proptype">) {
        Object.assign(this, args);
    }
}

export {
    FlowsheetTemplate,
    FlowsheetTemplateScope
};
